import {Router} from '@angular/router';
import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { OrganiserFormComponent } from '../organiser-form/organiser-form.component';
import { DetailFormComponent } from '../detail-form/detail-form.component';
import { ChannelsFormComponent } from '../channels-form/channels-form.component';
import { DescriptionFormComponent } from '../description-form/description-form.component';
import { VenueFormComponent } from '../venue-form/venue-form.component';
import { BookingFormComponent } from '../booking-form/booking-form.component';
import { PricingFormComponent } from '../pricing-form/pricing-form.component';
import { ImagesFormComponent } from '../images-form/images-form.component';
import { VideoFormComponent } from '../video-form/video-form.component';


import { SchemaConverter } from '../../../lib/schemaConverter';
import { ContributorService } from '../../../services/contributor.service';

import { ToastrService } from 'ngx-toastr';

import { MonitoringService } from 'src/app/services/monitoring.service';

@Component({
    standalone: false,
    selector: 'app-wizard',
    templateUrl: './wizard.component.html',
    styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit {

    @ViewChild(OrganiserFormComponent, {static: false}) organiserForm !: OrganiserFormComponent;
    @ViewChild(DetailFormComponent, {static: false}) detailForm !: DetailFormComponent;
    @ViewChild(ChannelsFormComponent, {static: false}) channelsForm !: ChannelsFormComponent;
    @ViewChild(DescriptionFormComponent, {static: false}) descriptionForm !: DescriptionFormComponent;
    @ViewChild(VenueFormComponent, {static: false}) venueForm !: VenueFormComponent;
    @ViewChild(BookingFormComponent, {static: false}) bookingForm !: BookingFormComponent;
    @ViewChild(PricingFormComponent, {static: false}) pricingForm !: PricingFormComponent;
    @ViewChild(ImagesFormComponent, {static: false}) imagesForm !: ImagesFormComponent;
    @ViewChild(VideoFormComponent, {static: false}) videoForm !: VideoFormComponent;
    @ViewChild('stepper', {static: false}) stepper;


    confirmationForm: FormGroup;


    title = "Organiser";
    isFirstStep = true;
    wizardForms: any[][];
    vm: any;
    stage: string;
    contributorService: ContributorService;
    converter: SchemaConverter;
    showJson = false;
    schema: any;
    devForm: FormGroup;

    constructor(contributorService: ContributorService, converter: SchemaConverter, private toastrService: ToastrService, private monitoringService: MonitoringService, private router: Router) {
        this.stage = "readme";
        // this.stage = "review";
        this.contributorService = contributorService
        this.converter = converter;
        this.devForm = new FormGroup({
            vmJson: new FormControl('', [])
        });

        this.vm = {
            organiserVm: {
            },
            detailVm: {
                occurrenceType: "OnceOff",
                selectedDates: []
            },
            descriptionVm: {},
            channelsVm: {},
            videoVm: {},
            imagesVm: {},
            venueVm: {},
            bookingVm: {},
            pricingVm: {},
        }
    }


    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {

        if (event.altKey && event.ctrlKey) {

            if (event.key == "j") {
                this.showJson = !this.showJson;
                this.schema = this.converter.convertToSchema(this.vm);
            }

            if (event.key == "b") {
                this.stage = "confirm"
            }

            if (event.key == "f") {
                this.stage = "form"
            }
        }
    }

    setVm() {
        const json = this.devForm.get('vmJson').value;
        var obj = JSON.parse(json);
        this.vm = obj;
    }

    backToForm() {
        this.stage = "form"

        // This is a known exception since recaptcha does not like the reset, but it is required to force the form control to return to initial state
        // and force user to tick the recaptcha in case of submission
        try {
            this.confirmationForm.controls.recaptchaForm.reset();
        } catch (ex) {
            console.error(`Reset of recaptcha error: ${JSON.stringify(ex)}`);
        }
        if (!this.confirmationForm.controls.recaptchaForm.errors) {
            this.confirmationForm.controls.recaptchaForm.setErrors({ required: true });
        }
    }

    startForm(){
        this.monitoringService.logEvent("Accepted Criteria", this.getEventMetadata());

        this.stage = "form"
    }

    goToSubmit(){
        this.monitoringService.logEvent("Reviewed Form", this.getEventMetadata());

        this.stage = "confirm"
    }

    ngOnInit() {
        this.confirmationForm = new FormGroup({
            recaptchaForm: new FormControl(null, Validators.required)
        });
    }

    ngAfterViewInit() {
        this.wizardForms = [
            [
                this.organiserForm
            ],
            [
                this.detailForm,
                this.descriptionForm,
                this.channelsForm
            ],
            [
                this.venueForm,
            ],
            [
                this.bookingForm,
                this.pricingForm
            ],
            [
                this.imagesForm,
                this.videoForm
            ]
        ]
    }

    options = {
        active: true
    }

    async submit() {

        this.options.active = false;

        this.monitoringService.logEvent("Event Submitted", this.getEventMetadata());

        // TODO - Handle issue
        // This is a temporary workaround for the images caption, since the trimming function is working for everything except images caption (dynamic controls)
        let images = this.vm.imagesVm.images;

        if (images && images instanceof Array) {
            images.forEach(img => {
                img.title = img.title.trim();
                img.description = img.description.trim();
            });
        }

        //Since it is last section, validates if all form is valid, in order to avoid user navigate using the wizzard and skipping data validation
        let formValid = this.validateAllForms();

        if (!formValid.isValid) {
            this.stage = "validationFailure";
            this.options.active = true;
            return;
        }

        const catchpaToken =  this.confirmationForm.value.recaptchaForm;
        const converted = this.converter.convertToSchema(this.vm);
        // this signature needs to be change, really the service should not be relaying back the response, otherwise its not an abstraction
        // should be creatEvent(..).subscribe, with the response being a domain object and custom exception ContributorError : Errror etc
        // P.
        this.contributorService.putEvent(converted, 
            { 
                reCatchpaToken : catchpaToken
            }).subscribe((res: any) => {
            console.log(`Event Saved Successfully : ${res.id}`);
            this.monitoringService.logEvent("Event Submitted Successfully", this.getEventMetadata(converted));
            this.options.active = true;

            this.stage = "complete";
            this.router.navigate(['/thank-you']);
        }, (error) => {

            this.monitoringService.logError(error);

            this.monitoringService.logEvent("Event Submission Failure", this.getEventMetadata(converted));
            this.options.active = true;
            if (error.status == 422) {
                this.stage = "submitFailure";
            }
            else {
                this.stage = "generalFailure";
            }
        }
        );
    }
    getEventMetadata(eventData = null): { [key: string]: string; } {

        return {
            "Event Name" : this.vm.detailVm.name,
            "Event Data" : eventData ? JSON.stringify(eventData, null, 4) : "",
            "Event VM" : this.vm ? JSON.stringify(this.vm, null, 4) : ""
        }
    }

    async wait(time) {

        return new Promise(resolve => setTimeout(resolve, time));
    }


    stepChanged(e) {
        this.title = e.selectedStep.label;

        this.monitoringService.logEvent("Navigated to " + this.title + " step", this.getEventMetadata() );
        this.isFirstStep = e.selectedIndex == 0;
    }

    goBack(stepper: MatStepper) {

        this.monitoringService.logEvent("Clicked Previous", this.getEventMetadata());
        stepper.previous();

        this.scrollToTop();
    }

    goToStep(event){
        this.monitoringService.logEvent(`Navigated to the ${event.value} step`, this.getEventMetadata());
        this.stage = "form"
        this.stepper.selectedIndex = event.value;

        // Just scroll for all sections, except the Event Details section, in order to leave the scroll in the position of the
        // information that the user wants to edit
        if(event.value != 1){
            this.scrollToTop();
        }

    }

    scrollToTop(){
        // scroll to selected step (Workaround to scrolltop since it is an open issue for the mat-stepper component)
        const stepElement = document.getElementsByClassName("pnl-register-event")[0];
        if (stepElement) {
            setTimeout(() => {
                stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
            }, 250);
        }
    }

    goForward(stepper: MatStepper) {

        this.monitoringService.logEvent("Clicked Next", this.getEventMetadata());
        const result = this.validateStepperForm(stepper);

        if (result.isValid) {
            if (stepper.selectedIndex === stepper._steps.length - 1) {
                this.stage = "review";
            }
            else {
                stepper.next();
            }

            this.scrollToTop();
        }
    }

    validateAllForms() {
        const result = {
            isValid: true
        }

        this.wizardForms.forEach(section => {
            if (section) {
                section.forEach(formGroup => {
                    result.isValid = result.isValid && formGroup.form.valid;
                });
            }
            else {
                result.isValid = false;
            }
        });

        return result;
    }

    validateForm(wform) {
        let isValid = true;
        if (wform && wform.form) {

            const formGroup = wform.form;
            const controls = formGroup.controls;
            for (const ctrlName in controls) {
                const ctrl = controls[ctrlName];
                ctrl.markAsTouched();
                if (ctrl.enabled)
                    isValid = isValid && ctrl.valid;
                else if (!ctrl.valid) {
                    ctrl.markAsUntouched();
                }
            }
        }

        return isValid;
    }

    validateStepperForm(stepper) {

        const result = {
            isValid: true
        }

        const forms = this.wizardForms[stepper.selectedIndex];
        if (forms) {
            forms.forEach(wizardForm => {

                // Line moved in order to force validation for all forms in the page. If validateForm is included in the and expression,
                // then if the first form is invalid, the second time it will not evaluate the form since the result from the first time is false.
                const isFormValid = this.validateForm(wizardForm);
                result.isValid = result.isValid && isFormValid;
            });
        }
        return result;
    }
}
